import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';

import {
  IntegrationProbeOutcomeSchema,
  PROBE_OK_ISSUE,
  probeOkMatchesCode,
} from '../integration-probe-result/integration-probe-result';

/**
 * The last test-connection a provider received — the stored fact, not the
 * transient answer to one click.
 *
 * A probe the platform forgets is a probe the panel cannot show: an operator who
 * reloads, a colleague who opens the screen tomorrow, and the person auditing the
 * setup all need to know what the last test concluded, when, and who ran it. So
 * the outcome is persisted per `(capability, provider)` and published here.
 *
 * `checkedByUserId` is nullable because the account that ran it may since have
 * been deleted — the probe still happened. `detail` is bounded and **redacted**
 * before it is ever stored: this shape is readable at `integrations.read`, a
 * weaker gate than the `integrations.<capability>.manage` that produced it, and a
 * vendor commonly echoes the credential it rejected (N21).
 */
export const IntegrationProbeStatusSchema = IntegrationProbeOutcomeSchema.extend({
  /** ISO 8601 **with an offset** — the same shape as every other date the api emits. */
  checkedAt: z.string().min(1),
  checkedByUserId: UuidSchema.nullable(),
})
  .strict()
  .refine(probeOkMatchesCode, PROBE_OK_ISSUE);

export type IntegrationProbeStatus = z.infer<typeof IntegrationProbeStatusSchema>;
